import { render } from "./TelkomZATerms.vue?vue&type=template&id=d0f47c6e&scoped=true"
import script from "./TelkomZATerms.vue?vue&type=script&lang=js"
export * from "./TelkomZATerms.vue?vue&type=script&lang=js"

import "./TelkomZATerms.vue?vue&type=style&index=0&id=d0f47c6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f47c6e"]])

export default __exports__